import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faGear, faEllipsisVertical, faPlus } from '@fortawesome/free-solid-svg-icons';

const ProjectSkeletonLoader = () => {
  const shimmerStyle = {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
  };

  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>

      <div className="p-0 pt-1 pb-3">
        {/* Header Skeleton */}
        {/* <div className="mb-0 pb-1 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                ...shimmerStyle,
                height: '28px',
                width: '150px',
                borderRadius: '4px',
              }}
            ></div>
          </div>
          <div
            className="d-flex align-items-center gap-1"
            style={{ height: "80px" }}
          >
         
            <div className="position-relative">
              <div
                style={{
                  ...shimmerStyle,
                  height: '36px',
                  width: '200px',
                  borderRadius: '4px',
                }}
              ></div>
            </div>

      
            <div
              style={{
                ...shimmerStyle,
                height: '36px',
                width: '40px',
                borderRadius: '4px',
              }}
            ></div>

    
            <div
              style={{
                ...shimmerStyle,
                height: '35px',
                width: '40px',
                borderRadius: '4px',
              }}
            ></div>
           <div
              style={{
                ...shimmerStyle,
                height: '35px',
                width: '40px',
                borderRadius: '4px',
              }}
            ></div>

      
            <div
              style={{
                ...shimmerStyle,
                height: '35px',
                width: '80px',
                borderRadius: '4px',
              }}
            ></div>
          </div>
        </div> */}

        <div className="tab-content mt-3">
          <div
            className="tab-pane ps-app-request-resp-table active ps-0 pe-0"
            id="pending-justified"
            role="tabpanel"
            style={{
              minHeight: "300px",
              padding: "0rem",
              overflowX: "auto",
              marginLeft: "2px",
            }}
          >
            <div className="ps-table-wrapper ps-app-request-box">
              {/* Table Header Skeleton */}
              <div className="mb-3">
                <div
                  style={{
                    ...shimmerStyle,
                    height: '20px',
                    width: '100%',
                    borderRadius: '4px',
                  }}
                ></div>
              </div>

              {/* Table Rows Skeleton */}
              <div style={{ padding: '0 10px' }}>
                {[1, 2, 3, 4, 5].map((row) => (
                  <div
                    key={row}
                    className="d-flex align-items-center mb-3"
                    style={{
                      background: '#fff',
                      borderRadius: '8px',
                      padding: '12px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      border: '1px solid #f0f0f0',
                    }}
                  >
                    {/* Serial Number */}
                    <div
                      style={{
                        width: '50px',
                        marginRight: '15px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '20px',
                          width: '30px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* Contact Avatar and Name */}
                    <div
                      style={{
                        minWidth: '250px',
                        marginRight: '20px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          marginRight: '10px',
                        }}
                      ></div>
                      <div>
                        <div
                          style={{
                            ...shimmerStyle,
                            height: '16px',
                            width: '120px',
                            borderRadius: '4px',
                            marginBottom: '6px',
                          }}
                        ></div>
                        <div
                          style={{
                            ...shimmerStyle,
                            height: '14px',
                            width: '100px',
                            borderRadius: '4px',
                          }}
                        ></div>
                      </div>
                    </div>

                    {/* Project Title */}
                    <div
                      style={{
                        minWidth: '200px',
                        marginRight: '20px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '16px',
                          width: '150px',
                          borderRadius: '4px',
                          marginBottom: '6px',
                        }}
                      ></div>
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '180px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* Description */}
                    <div
                      style={{
                        minWidth: '150px',
                        marginRight: '20px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '80px',
                          borderRadius: '4px',
                          marginBottom: '6px',
                        }}
                      ></div>
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '130px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* Start Date */}
                    <div
                      style={{
                        minWidth: '120px',
                        marginRight: '20px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '70px',
                          borderRadius: '4px',
                          marginBottom: '6px',
                        }}
                      ></div>
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '100px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* End Date */}
                    <div
                      style={{
                        minWidth: '120px',
                        marginRight: '20px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '70px',
                          borderRadius: '4px',
                          marginBottom: '6px',
                        }}
                      ></div>
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '100px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* Status */}
                    <div
                      style={{
                        minWidth: '100px',
                        marginRight: '20px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '14px',
                          width: '60px',
                          borderRadius: '4px',
                          marginBottom: '6px',
                        }}
                      ></div>
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '20px',
                          width: '80px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>

                    {/* Actions */}
                    <div
                      style={{
                        minWidth: '40px',
                      }}
                    >
                      <div
                        style={{
                          ...shimmerStyle,
                          height: '20px',
                          width: '20px',
                          borderRadius: '4px',
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Pagination Skeleton */}
        <div className="pagination-container d-flex justify-content-between align-items-center gap-2 mt-1 mb-1">
          <div
            style={{
              ...shimmerStyle,
              height: '16px',
              width: '120px',
              borderRadius: '4px',
            }}
          ></div>

          <div className="d-flex">
            <div
              style={{
                ...shimmerStyle,
                height: '38px',
                width: '78px',
                borderRadius: '4px',
                marginRight: '10px',
              }}
            ></div>

            <div className="d-flex align-items-center gap-3">
              <div
                style={{
                  ...shimmerStyle,
                  height: '38px',
                  width: '200px',
                  borderRadius: '4px',
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectSkeletonLoader;